import React from 'react';
import { CorporatePreviewTemplate } from 'themes/application/corporate/pages';
import { observer } from 'mobx-react';
import { CorporatePreviewStore } from 'application/corporate/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new CorporatePreviewStore(rootStore), 'corporatePreviewStore')
@observer
class CorporatePreview extends React.Component {
    render() {
        return <CorporatePreviewTemplate {...this.props} />
    }
}

export default CorporatePreview;
